/**
 * Утилита для загрузки Yandex Maps API
 */

declare global {
  interface Window {
    ymaps: any;
  }
}

let loadPromise: Promise<void> | null = null;

/**
 * Загружает Yandex Maps API с API ключом
 */
export function loadYandexMaps(): Promise<void> {
  if (window.ymaps) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const apiKey = import.meta.env.VITE_YANDEX_MAPS_API_KEY;
    
    if (!apiKey) {
      console.warn('VITE_YANDEX_MAPS_API_KEY не установлен. Yandex Maps может не работать.');
    }

    const script = document.createElement('script');
    const url = apiKey 
      ? `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${apiKey}`
      : 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      if (window.ymaps) {
        window.ymaps.ready(() => {
          resolve();
        });
      } else {
        reject(new Error('Yandex Maps API не загрузился'));
      }
    };

    script.onerror = () => {
      reject(new Error('Ошибка загрузки Yandex Maps API'));
    };

    document.head.appendChild(script);
  });

  return loadPromise;
}

